<script setup lang="ts">
import { Teleport } from 'vue'
import GlobalHeader from '@/components/desktop/GlobalHeader/index.vue'
import MostRead from '@/components/desktop/MostRead/index.vue'
import Recommond from '@/components/desktop/SuggestList'
import FooterSiteMap from '@/components/desktop/GlobalFooter/FooterSiteMap.vue'
import FooterShare from '@/components/desktop/GlobalFooter/FooterShare.vue'

import RotatChart from '@/views/live/desktop/rotatChart/index.vue'
import Share from '@/views/live/desktop/Share/index.vue'
import { getTextHeight } from '@/utils/util'

const style = getComputedStyle(document.querySelector('.live-extra-block .title'))

const height = getTextHeight(document.querySelector('.live-extra-block .title').textContent, {
  fontSize: '28px',
  lineHeight: '36px',
  width: '879px',
  textIndent: style.textIndent
})

if (height > (2 * 36)) {
  // @ts-ignore
  document.querySelector('.live-player-bottom').style.overflow = 'auto'
}
</script>

<template>
  <Teleport to="#globalHeader">
    <GlobalHeader />
  </Teleport>
  <Teleport to="#sharePic">
    <Share />
  </Teleport>
  <Teleport to="#mostRead">
    <MostRead />
  </Teleport>
  <Teleport to="#recommend">
    <Recommond type="suggest" />
  </Teleport>
  <Teleport to="#footerSitemap">
    <FooterSiteMap />
  </Teleport>
  <Teleport to="#footerShare">
    <FooterShare />
  </Teleport>
  <Teleport to="#rotatChart">
    <RotatChart />
  </Teleport>
</template>

<style scoped lang="less">

</style>
